import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import UserCard from 'flarum/forum/components/UserCard';
import ItemList from 'flarum/common/utils/ItemList';
import humanTime from 'flarum/common/utils/humanTime';
export default class SmallUserCard extends UserCard {
  constructor() {
    super(...arguments);
    _defineProperty(this, "attrs", void 0);
  }
  //Overriding infoItems so that other extensions can separately add items to small cards
  infoItems() {
    const items = new ItemList();
    const user = this.attrs.user;
    items.add('joined', app.translator.trans('core.forum.user.joined_date_text', {
      ago: humanTime(user.joinTime())
    }));
    return items;
  }
}
flarum.reg.add('fof-user-directory', 'forum/components/SmallUserCard', SmallUserCard);